<script setup lang="ts">
const { isMobile_lg } = useWindowWidth()
</script>

<template>
	<section class="places" data-aos="fade-up">
		<div class="places__container">
			<div class="places__container-text">
				<h3 v-if="!isMobile_lg" class="places__title">
					{{ $t('modules.about_us_module.about_us_places.we_are_in') }}
					<span>{{ $t('modules.about_us_module.about_us_places.119_places') }}</span
					><br />{{ $t('modules.about_us_module.about_us_places.in_poland') }}
				</h3>
				<h3 v-if="isMobile_lg" class="places__title">
					{{ $t('modules.about_us_module.about_us_places.we_are') }}<br />{{ $t('modules.about_us_module.about_us_places.in') }}
					<span>{{ $t('modules.about_us_module.about_us_places.119_places') }}</span
					><br />{{ $t('modules.about_us_module.about_us_places.in_poland') }}
				</h3>
				<p class="places__description">
					{{ $t('modules.about_us_module.about_us_places.our_branches') }}
				</p>
			</div>
			<div>
				<GlobalImage class="places__map" alt="About us places" src="about-us-places-map-v3.png" :width="1026" />
			</div>
			<!-- <GlobalImage class="places__borders" src="about-us-places-borders.png" :width="1240" /> -->
		</div>
	</section>
</template>

<style scoped lang="scss">
@import './AboutUsPlaces.scss';
</style>
